import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';
import BlockUI from 'primevue/blockui';
import PrimeVue from 'primevue/config';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import ProgressSpinner from 'primevue/progressspinner';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Row from 'primevue/row';
import ColumnGroup from 'primevue/columngroup';     //optional for column grouping
import Tooltip from 'primevue/tooltip';
import SplitButton from 'primevue/splitbutton';
import Dropdown from 'primevue/dropdown';
import Dialog from 'primevue/dialog';
import AutoComplete from 'primevue/autocomplete';
import Sidebar from 'primevue/sidebar';
import Listbox from 'primevue/listbox';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import ToggleButton from 'primevue/togglebutton';
import Chart from 'primevue/chart';
import Skeleton from 'primevue/skeleton';
import ProgressBar from 'primevue/progressbar';
// chart 
import VueApexCharts from 'vue-apexcharts'
import 'primevue/resources/themes/saga-blue/theme.css'       //theme
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
// add firebase
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA1JYoA3rYS7tEYX5pv-wqrB-Z8F9okkDE",
  authDomain: "vuejswithfirebase-6a588.firebaseapp.com",
  projectId: "vuejswithfirebase-6a588",
  storageBucket: "vuejswithfirebase-6a588.appspot.com",
  messagingSenderId: "627059323073",
  appId: "1:627059323073:web:b4d8d2c8bc2d26e20da440"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// export default db;
//ENd firebase

Vue.use(ToastService);
Vue.use(PrimeVue);
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(ConfirmationService);
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
Vue.component('Chart', Chart);
Vue.component('AutoComplete', AutoComplete);
Vue.component('Dialog', Dialog);
Vue.component('DataTable', DataTable);
Vue.component('Column', Column);
Vue.component('ColumnGroup', ColumnGroup);
Vue.component('InputText', InputText);
Vue.component('Calendar', Calendar);
Vue.component('Password', Password);
Vue.component('Button', Button);
Vue.component('Checkbox', Checkbox);
Vue.component('ToggleButton', ToggleButton);
Vue.component('Toast', Toast);
Vue.component('InputNumber', InputNumber);
Vue.component('ProgressSpinner', ProgressSpinner);
Vue.component('Row', Row);
Vue.component('Tooltip', Tooltip);
Vue.component('SplitButton', SplitButton);
Vue.component('Dropdown', Dropdown);
Vue.component('Sidebar', Sidebar);
Vue.component('Listbox', Listbox);
Vue.component('ConfirmDialog', ConfirmDialog);
Vue.component('BlockUI', BlockUI);
Vue.component('Skeleton', Skeleton);
Vue.component('ProgressBar', ProgressBar);
// setting global variable
// Only use in v2
// Vue.prototype.$urlAPI = 'https://api.megacare.top/megacareapi'
// Vue.prototype.$auth = {
//   username: "admin",
//   password: "MR8QS1KbhLngMl8y9KTqocoagp1RJBkj",
// }
// Only use in v1
Vue.prototype.$urlAPI = 'https://us-central1-emerald-cumulus-319304.cloudfunctions.net/MegaEdu?secret=vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3'
// Vue.prototype.$urlAPI = 'https://script.google.com/macros/s/AKfycbxPFefWwaqoeCZ9lLvbbKKz3-HiO_I7f-gqTCcvZ60MWkZ4soPIraun3DqIW7rnluKaQQ/exec?secret=vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3'
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
